/* eslint-disable no-unused-vars */
import React, { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import swal from "sweetalert";
import {
  loadingToggleAction,
  signupAction,
} from "../../store/actions/AuthActions";
import appLogo from "../../images/appLogo.png";
import { useTranslation } from "react-i18next";
import { MultiSelect } from "react-multi-select-component";
import yellowLogo from "../../icons/logo/logo_transparent_background.png";
import { Modal } from "react-bootstrap";
import { useLoadScript, StandaloneSearchBox } from "@react-google-maps/api";


const otherInterest = [
  {
    label: "Volunteering member",
    children: [],
  },
  {
    label: "Professional association member",
    children: [],
  },
  {
    label: "Politics",
    children: [],
  },
  {
    label: "Sports",
    children: [
      {
        label: "Basket-ball",
        value: "Basket-ball",
      },
      {
        label: "Football",
        value: "Football",
      },
      {
        label: "Soccer",
        value: "Soccer",
      },
      {
        label: "Baseball",
        value: "Baseball",
      },
      {
        label: "Golf",
        value: "Golf",
      },
      {
        label: "Tennis",
        value: "Tennis",
      },
    ],
  },
  {
    label: "Outooring  activities",
    children: [
      {
        label: "Kayak",
        value: "Kayak",
      },
      {
        label: "Biking",
        value: "Biking",
      },
      {
        label: "Hicking",
        value: "Hicking",
      },
      {
        label: "Alpine ski",
        value: "Alpine ski",
      },
      {
        label: "Crosscountry ski",
        value: "Crosscountry ski",
      },
    ],
  },
  {
    label: "Theater - Movies",
    children: [
      {
        label: "Drama",
        value: "Drama",
      },
      {
        label: "Suspense",
        value: "Suspense",
      },
      {
        label: "Horror",
        value: "Horror",
      },
      {
        label: "Comedy",
        value: "Comedy",
      },
    ],
  },
  {
    label: "Dance",
    children: [
      {
        label: "Hip Hop",
        value: "Hip Hop",
      },
      {
        label: "Latin",
        value: "Latin",
      },
      {
        label: "Social",
        value: "Social",
      },
      {
        label: "Disco",
        value: "Disco",
      },
      {
        label: "Ballet",
        value: "Ballet",
      },
    ],
  },
];

export const getBase64 = (file) => {
  return new Promise((resolve) => {
    let base64URL = "";
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      base64URL = reader.result;
      resolve(base64URL);
    };
  });
};
const libraries = ["places"];


function Register(props) {
   const { isLoaded } = useLoadScript({
      googleMapsApiKey: "AIzaSyB3n919-1MbNDn_jkTYcM0v4wVCoAWxRA0",
      libraries,
    });
  const [showConfirmPass, setShowConfirmPass]=useState(false);
  const [showPass, setShowPass]=useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [isIterestItemsShow, setIsIterestItemsShow] = useState(false);
  const [subInterest, setSubInterest] = useState([]);
  const [selectedOtherInterest, setSelectedOtherInterest] = useState("");
  const [selectedSubInterest, setSelectedSubInterest] = useState([]);
  const [firstname, setFirstname] = useState("");

  const [lastname, setLastname] = useState("");

  const [username, setUsername] = useState("");

  const [password, setPassword] = useState("");

  const [confirmPwd, setConfirmPwd] = useState("");

  const [phone, setPhone] = useState("");

  const [email, setEmail] = useState("");

  const fileInputRef = useRef(null);

  const [selectedFile, setSelectedFile] = useState(null);

  const [base64, setBase64] = useState("");

  const [address, setAddress] = useState("");

  const [city, setCity] = useState("");

  const [country, setCountry] = useState("");

  const [signupTriggered, setSignupTriggered] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showTermsError, setShowTermsError] = useState(false);

   // address autocomplete 
    const searchBoxRef = useRef(null);
    
    const handlePlacesChanged = () => {
        console.log(searchBoxRef.current,"adresse")
       if (!searchBoxRef.current) return; // 
  
        setAddress("");
        setCity("");
        setCountry("");
      const places = searchBoxRef.current.getPlaces();
      if (places.length > 0) {
        const place = places[0];
        const addressComponents = place.address_components;
  
        let address  = "";
        let streetNumber="";
        let route ="";
        let city = "";
        let region = "";
        let postalCode = "";
        let country = "";
  
        addressComponents.forEach((component) => {
          const types = component.types;
  
          if (types.includes("street_number")) {
            address = component.long_name ;
          }
          if (types.includes("route")) {
            address = component.long_name;
          }
          if (types.includes("locality")) {
            city = component.long_name;
          }
          if (types.includes("administrative_area_level_1")) {
            region = component.long_name;
          }
          if (types.includes("postal_code")) {
            postalCode = component.long_name;
          }
          if (types.includes("country")) {
            country = component.long_name;
          }
        });
  
        setAddress(address); 
  
        setCity(city);
        setCountry(country);
      }
    };
  // End address autocomplete


  const onChangePhoto = async (e) => {
    const file = e.target.files[0];

    const sizeLimit = 50 * 1024 * 1024; // 50MB

    if (file) {
      const fileType = file.type;

      if (file.size > sizeLimit) {
        swal("Oops", "Max File Size is 50 MB!", "error", {
          button: "Try Again!",
        });

        fileInputRef.current.value = "";
        setSelectedFile(null);

        setBase64("");

        return;
      }

      // Check if the selected file is of type jpg or png
      if (fileType === "image/jpeg" || fileType === "image/png") {
        setSelectedFile(e.target.files[0]);
      } else {
        fileInputRef.current.value = "";

        setSelectedFile(null);
        setBase64("");

        swal("Oops", "Please select a valid JPG or PNG file.", "error", {
          button: "Try Again!",
        });
      }
    }
  };

  const onSignUp = (e) => {
    e.preventDefault();
    if (acceptTerms) {
      if (
        firstname === "" ||
        lastname === "" ||
        username === "" ||
        password === "" ||
        confirmPwd === "" ||
        email === "" ||
        country === ""
      ) {
        setSignupTriggered(true);
      } else {
        setSignupTriggered(false);
        dispatch(loadingToggleAction(true));
        // Create FormData object
        const formData = new FormData();
        formData.append("firstname", String(firstname || ""));
        formData.append("lastname", String(lastname || ""));
        formData.append("username", String(username || ""));
        formData.append("password", String(password || ""));
        formData.append("confirmpassword", String(confirmPwd || ""));
        formData.append("phone", String(phone || ""));
        formData.append("email", String(email || ""));
        formData.append("address", String(address || ""));
        formData.append("city", String(city || ""));
        formData.append("country", String(country || ""));
        formData.append("otherinterests", String(selectedOtherInterest || ""));

        // Append sub-interests as a JSON string
        if (selectedSubInterest && selectedSubInterest.length > 0) {
          const subInterestsArray = selectedSubInterest.map(
            (item) => item.label || ""
          );
          formData.append("subinterests", JSON.stringify(subInterestsArray));
        } else {
          formData.append("subinterests", JSON.stringify([]));
        }

        // Append profile picture if selected
        if (selectedFile) {
          formData.append("profilepicture", selectedFile);
        }
        dispatch(signupAction(formData, navigate));
      }
    } else {
      setShowTermsError(true);
    }
  };
  const onInterestChangeHandler = (e) => {
    if (e.target.value !== "") {
      setSelectedOtherInterest(e.target.value);
      const result = otherInterest.find(
        (item) => item.label === e.target.value
      );
      if (result.children?.length !== 0) {
        setSubInterest(result.children);
        setIsIterestItemsShow(true);
      } else {
        setSelectedSubInterest([]);
        setSubInterest([]);
        setIsIterestItemsShow(false);
      }
    }
  };
   if (!isLoaded) return <div>Loading...</div>;

  return (
    <div className="authincation h-100 p-meddle">
      <div className="container h-100">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-8">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className="text-center mb-3">
                      <Link to="/login">
                        <img
                          src={yellowLogo}
                          alt="appLogo"
                           style={{ width: "50px" }}
                          className="img-fluid mb-1"
                          // style={{
                          //   height: "42px",
                          //   width: "52px",
                          //   marginRight: "12px",
                          // }}
                        />
                        <h3
                          style={{
                            fontSize: "30px",
                            fontWeight: "600",
                            verticalAlign: "middle",
                            color: "var(--secondary)",
                          }}
                        >
                          AMG Global
                        </h3>
                      </Link>
                    </div>

                    <h4 className="mt-4" >{t("signUpTitle")}</h4><hr/><br/>

                    <form onSubmit={onSignUp}>
                    <div className="row">
                        <div
                          className={`form-group col-md-6 col-sm-12 ${
                            signupTriggered && firstname === "" ? "" : "mb-3"
                          }`}
                        >
                          <label className="mb-1"><strong>{t("signUpFirstnameInput")}</strong><span className="text-danger">*</span></label>
                          <input
                            type="text"
                            placeholder={t("signUpFirstnamePlaceholder")}
                            className="form-control"
                            value={firstname}
                            onChange={(e) => setFirstname(e.target.value)}
                          />
                        {signupTriggered && firstname === "" && (
                          <div className="text-danger fs-12">
                            {t("signUpFirstnamePlaceholder")}{" "}
                            {t("globalIsRequired")}
                          </div>
                        )}
                        </div>
                        <div
                          className={`form-group col-md-6 col-sm-12 ${
                            signupTriggered && lastname === "" ? "" : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                              <strong>{t("signUpLastnameInput")}</strong><span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder={t("signUpLastnamePlaceholder")}
                            className="form-control"
                            value={lastname}
                            onChange={(e) => setLastname(e.target.value)}
                          />
                      {signupTriggered && lastname === "" && (
                        <div className="text-danger fs-12">
                          {t("signUpLastnamePlaceholder")}{" "}
                          {t("globalIsRequired")}
                        </div>
                      )}
                        </div>
                      </div>

                      <div className="row">
                          <div
                            className={`form-group col-md-6 col-sm-12 ${
                              signupTriggered && username === "" ? "" : "mb-3"
                            }`}
                          >
                            <label className="mb-1">
                              <strong>{t("signUpUsernameInput")}</strong><span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder={t("signUpUsernamePlaceholder")}
                              className="form-control"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                            />
                          {signupTriggered && username === "" && (
                            <div className="text-danger fs-12">
                              {t("signUpUsernamePlaceholder")}{" "}
                              {t("globalIsRequired")}
                            </div>
                          )}
                          </div>
                          <div
                            className={`form-group col-md-6 col-sm-12 ${
                              signupTriggered && password === "" ? "" : "mb-3"
                            }`}
                          >
                            <label className="mb-1 "><strong>{t("signUpPasswordInput")}</strong><span className="text-danger">*</span>
                            </label>
                            
                            <div className="input-group">
                            <input
                              type={showPass?"text":"password"}
                              placeholder={t("signUpPasswordPlaceholder")}
                              className="form-control"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />

                              <div className="input-group-append">
                                <span className="form-control" style={{backgroundColor:"#ecececff", cursor:"pointer"}} onClick={()=>setShowPass(!showPass)}><i className={`fa ${showPass?"fa-eye-slash":"fa-eye"}`}></i></span>
                              </div>
                          {signupTriggered && password === "" && (
                            <div className="text-danger fs-12">
                              {t("signUpPasswordPlaceholder")}{" "}
                              {t("globalIsRequired")}
                            </div>
                          )}
                            </div>

                          </div>
                      </div>

                      <div className="row">
                        <div
                          className={`form-group col-md-6 col-sm-12 ${
                            signupTriggered && confirmPwd === "" ? "" : "mb-3"
                          }`}
                        >
                          <label className="mb-1 ">
                            <strong>{t("signUpConfirmPasswordInput")}</strong><span className="text-danger">*</span>
                          </label>
                          <div className="input-group">

                            <input
                              type={showConfirmPass?"text":"password"}
                              placeholder={t("signUpConfirmPasswordPlaceholder")}
                              className="form-control"
                              value={confirmPwd}
                              onChange={(e) => setConfirmPwd(e.target.value)}
                            />
                          <div className="input-group-append">
                              <span className="form-control" style={{backgroundColor:"#ecececff", cursor:"pointer"}} onClick={()=>setShowConfirmPass(!showConfirmPass)}><i className={`fa ${showConfirmPass?"fa-eye-slash":"fa-eye"}`}></i></span>
                          </div>
                          </div>
                        {signupTriggered && confirmPwd === "" && (
                          <div className="text-danger fs-12">
                            {t("signUpConfirmPasswordPlaceholder")}{" "}
                            {t("globalIsRequired")}
                          </div>
                        )}
                        </div>
                        {signupTriggered &&
                          confirmPwd !== "" &&
                          confirmPwd !== password && (
                            <div className="text-danger fs-12">
                              {t("hconfirmPass")}
                            </div>
                          )}
                        <div className="form-group mb-3 col-md-6 col-sm-12">
                          <label className="mb-1">
                            <strong>{t("signUpPhoneInput")}</strong>
                          </label>
                          <input
                            type="text"
                            placeholder={t("signUpPhonePlaceholder")}
                            className="form-control"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                          />
                        </div>
                      </div>

                      <div
                        className={`form-group col-md-12 col-sm-12 ${
                          signupTriggered && email === "" ? "" : "mb-3"
                        }`}
                      >
                        <label className="mb-1">
                          <strong>{t("signUpEmailInput")}</strong><span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          placeholder={t("signUpEmailPlaceholder")}
                          className="form-control"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      {signupTriggered && email === "" && (
                        <div className="text-danger fs-12">
                          {t("api.amgapi.err.020")} 
                        </div>
                      )}
                      </div>
                      <div className="form-group mb-3">
                        <label className="mb-1">
                          <strong>{t("signUpPhotoInput")}</strong><span className="text-danger">*</span>
                        </label>
                        <input
                          type="file"
                          accept=".jpg, .jpeg, .png"
                          className="form-control"
                          ref={fileInputRef}
                          onChange={onChangePhoto}
                        />
                      {signupTriggered && base64 === "" && (
                        <div className="text-danger fs-12">
                          {t("signUpPhotoInput")} {t("globalIsRequired")}
                        </div>
                      )}
                      </div>
                      <div className="row">
                        <div className="form-group col-md-6 col-sm-12 mb-3">
                          <label className="mb-1">
                            <strong>{t("signUpAddressInput")}</strong>
                          </label>
                       <StandaloneSearchBox onLoad={(ref) => (searchBoxRef.current = ref)} onPlacesChanged={handlePlacesChanged}>
                          <input
                            type="text"
                            placeholder={t("signUpAddressPlaceholder")}
                            className="form-control"
                            value={address}
                            onChange={(e) =>{
                              setAddress(e.target.value)
                              setCity("");
                              setCountry("");
                            } }
                          />
                       </StandaloneSearchBox>

                        </div>
                        <div className="form-group col-md-6 col-sm-12 mb-3">
                          <label className="mb-1">
                            <strong>{t("signUpCityInput")}</strong>
                          </label>
                          <input
                            type="text"
                            placeholder={t("signUpCityPlaceholder")}
                            className="form-control"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="row">
                      <div
                        className={`form-group col-md-6 col-sm-12 ${
                          signupTriggered && country === "" ? "" : "mb-3"
                        }`}
                      >
                        <label className="mb-1">
                           <strong>{t("signUpCountrynput")}</strong><span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder={t("signUpCountryPlaceholder")}
                          className="form-control"
                          value={country}
                          onChange={(e) => setCountry(e.target.value)}
                        />
                      {signupTriggered && country === "" && (
                        <div className="text-danger fs-12">
                          {t("signUpCountryPlaceholder")}{" "}
                          {t("globalIsRequired")}
                        </div>
                      )}
                      </div>

                      <div className="form-group col-md-6 col-sm-12 mb-3">
                        <label className="mb-1">
                          <strong>{t("hotherInterests")}</strong><span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control"
                          style={{ border: "1px solid #EEEEEE" }}
                          onChange={onInterestChangeHandler}
                        >
                          <option value="">{t("globalSelect")}</option>
                          {otherInterest?.map((item, index) => (
                            <option value={item.label} key={index}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                        {isIterestItemsShow && (
                          <div className="form-group mb-3">
                            <label className="mb-1">
                              <strong>{t("harea")}</strong>
                            </label>
                            <MultiSelect
                              hasSelectAll={false}
                              disableSearch={false}
                              options={subInterest}
                              value={selectedSubInterest}
                              onChange={setSelectedSubInterest}
                              labelledBy="Select"
                            />
                          </div>
                        )}
                      </div>
                      </div>

                      <p
                        className="text-info"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowTerms(true)}
                      >
                        {t("hseecondition")}
                      </p>
                      {showTermsError && (
                        <p className="text-danger" style={{ fontSize: "10px" }}>
                          {t("hnotaccept")}
                        </p>
                      )}

                      <div className="text-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                          onClick={() => console.log("test")}
                        >
                          {t("signUpSubmitButton")}
                        </button>
                      </div>
                    </form>

                    <div className="new-account mt-3">
                      <p className="">
                        {t("signUphaveaccount")}{" "}
                        <Link className="text-primary" to="/login">
                          {t("signInButton")}
                        </Link>
                      </p>
                    </div>
                    <Modal
                      className="modal fade"
                      show={showTerms}
                      onHide={setShowTerms}
                    >
                      <div className="p-4" role="document">
                        <h3>{t("terms_n_conditions")}</h3>

                        <div className="my-5 ">
                          <ol className="list-group list-group-numbered">
                            <li className="my-2" style={{ fontSize: "15px" }}>
                              {t("agreement_introduction")}
                            </li>
                            <li className="my-2" style={{ fontSize: "15px" }}>
                              {t("agreement_prohibited_activities")}
                            </li>
                            <li className="my-2" style={{ fontSize: "15px" }}>
                              {t("agreement_dispute_resolution")}
                            </li>
                            <li className="my-2" style={{ fontSize: "15px" }}>
                              {t("agreement_limitation_liabilities")}
                            </li>
                            <li className="my-2" style={{ fontSize: "15px" }}>
                              {t("agreement_returns_refund")}
                            </li>
                            <li className="my-2" style={{ fontSize: "15px" }}>
                              {t("agreement_contact_information")}
                            </li>
                          </ol>
                          <button
                            className="mt-5 btn btn-primary btn-block"
                            onClick={() => {
                              setShowTermsError(false);
                              setAcceptTerms(true);
                              setShowTerms(false);
                            }}
                          >
                            {t("hAccept")}
                          </button>
                        </div>
                      </div>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};

export default connect(mapStateToProps)(Register);
